import { Button, Checkbox, Icon, Loading } from '@smartgift/frontend-toolkit';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import * as TableS from '@hero/components/molecules/Table/style';
import { formatNumber } from '@hero/utils';

import * as S from '../Advance/style';

function RecipientSelectionHead({ table }) {
  const { t } = useTranslation();

  const [toggleSelectAll, setToggleSelectAll] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const rowSelection = useMemo(() => {
    return table.getState()?.rowSelection;
  }, [table.getState()?.rowSelection]);

  const totalRowCount = useMemo(() => {
    return table.getState()?.pagination?.total;
  }, [table.getState()?.pagination?.total]);

  const selectedRowCount = useMemo(() => {
    return Object.keys(rowSelection || {}).length;
  }, [rowSelection]);

  const onToggleSelectAll = async () => {
    if (toggleSelectAll) {
      table.resetRowSelection();
    } else {
      setIsLoading(true);
      await table.getState().onToggleSelectAll?.(table);
      setIsLoading(false);
    }

    setToggleSelectAll(!toggleSelectAll);
  };

  React.useEffect(() => {
    if (selectedRowCount === 0) {
      setToggleSelectAll(false);
    }
    if (selectedRowCount === totalRowCount) {
      setToggleSelectAll(true);
    }
  }, [selectedRowCount, totalRowCount]);

  return (
    <TableS.HeadSelected>
      <TableS.HeadCheckbox>
        <Checkbox
          {...{
            key: table.getState().pagination.pageIndex,
            name: 'selectAll',
            indeterminate: table.getIsSomeRowsSelected(),
            checked: table.getIsAllRowsSelected(),
            onChange: table.getToggleAllRowsSelectedHandler()
          }}
        />
      </TableS.HeadCheckbox>
      <TableS.HeadSelectedItems>
        <TableS.HeadSelectedItems>
          <Icon name="contacts" px={32} space={7} />
          <S.SelectedContactText>
            {t(toggleSelectAll ? 'nContactAreSelected' : 'selectedRowCount', {
              selectedRowCount: selectedRowCount,
              selectedTypo: selectedRowCount,
              totalContactCount: totalRowCount
            })}
          </S.SelectedContactText>
        </TableS.HeadSelectedItems>
        <S.SelectAllArea>
          {!(!toggleSelectAll && totalRowCount - selectedRowCount <= 0) &&
            table.getPageCount() > 1 && (
              <S.SelectAllContactButton color="neutral" variant="link" onClick={onToggleSelectAll}>
                {t(toggleSelectAll ? 'clearSelection' : 'selectRemainingNType', {
                  totalContactCount: formatNumber(totalRowCount - selectedRowCount),
                  type: t('contacts').toLocaleLowerCase()
                })}
              </S.SelectAllContactButton>
            )}

          {isLoading && <Loading size="sm" type="ring" />}
        </S.SelectAllArea>
      </TableS.HeadSelectedItems>
      <S.CustomSelectionHeadCenter>
        <Button
          startIcon={<Icon name="delete" />}
          color="error"
          size="sm"
          variant="outlined"
          onClick={table.getState().onRemoveSelectedRows}
        >
          {t('remove')}
        </Button>
      </S.CustomSelectionHeadCenter>
    </TableS.HeadSelected>
  );
}

export { RecipientSelectionHead };
